import { render, staticRenderFns } from "./ShippingInformation.vue?vue&type=template&id=188ebc14"
import script from "./ShippingInformation.vue?vue&type=script&lang=js"
export * from "./ShippingInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports